import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import Upload from "../../components/Upload";
var inputs = document.querySelectorAll('input[type="file"]');
for (var i = 0; i < inputs.length; i++) {
    var input = inputs.item(i);
    var root = document.createElement('div');
    input.parentNode.insertBefore(root, input.nextSibling);
    root.style.display = input.style.display;
    input.style.display = 'none';
    ReactDOM.render(_jsx(Upload, { element: input, saveUrl: input.getAttribute('data-save-url') }), root);
}
